<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page==='showing'"
    class="page"
  >
    <Header
      :setting="{
        title: '預約掛號',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div class="fc--primary mb4">
      {{ clinic.fullname }}
    </div>
    <div class="page__is-expanded bc--tertiary">
      <div class="p4 row--scroll-x">
        <div
          v-for="division in clinic.appointmentDivisions"
          :key="division.division"
          :class="{
            'bc--accent': choice.division === division.division,
            'fc--white': choice.division === division.division
          }"
          @click="choice.division = division.division"
          class="label ph4"
        >
          {{ division.division }}
        </div>
      </div>
    </div>
    <div class="page__is-expanded bc--primary mb4">
      <div class="pv3 ph4 row--scroll-x">
        <div
          :class="{
            'bc--secondary': choice.week === 0,
            'fc--primary': choice.week === 0,
            'fc--white': choice.week !== 0,
          }"
          @click="choice.week = 0"
          class="label ph3"
        >
          一週內
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 1,
            'fc--primary': choice.week === 1,
            'fc--white': choice.week !== 1,
          }"
          @click="choice.week = 1"
          class="label ph3"
        >
          下一週
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 2,
            'fc--primary': choice.week === 2,
            'fc--white': choice.week !== 2,
          }"
          @click="choice.week = 2"
          class="label ph3"
        >
          ２週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 3,
            'fc--primary': choice.week === 3,
            'fc--white': choice.week !== 3,
          }"
          @click="choice.week = 3"
          class="label ph3"
        >
          3週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 4,
            'fc--primary': choice.week === 4,
            'fc--white': choice.week !== 4,
          }"
          @click="choice.week = 4"
          class="label ph3"
        >
          4週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 5,
            'fc--primary': choice.week === 5,
            'fc--white': choice.week !== 5,
          }"
          @click="choice.week = 5"
          class="label ph3"
        >
          5週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 6,
            'fc--primary': choice.week === 6,
            'fc--white': choice.week !== 6,
          }"
          @click="choice.week = 6"
          class="label ph3"
        >
          6週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 7,
            'fc--primary': choice.week === 7,
            'fc--white': choice.week !== 7,
          }"
          @click="choice.week = 7"
          class="label ph3"
        >
          7週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 8,
            'fc--primary': choice.week === 8,
            'fc--white': choice.week !== 8,
          }"
          @click="choice.week = 8"
          class="label ph3"
        >
          8週後
        </div>
        <!--
        <div
          :class="{
            'bc--secondary': choice.week === 9,
            'fc--primary': choice.week === 9,
            'fc--white': choice.week !== 9,
          }"
          @click="choice.week = 9"
          class="label ph3"
        >
          9週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 10,
            'fc--primary': choice.week === 10,
            'fc--white': choice.week !== 10,
          }"
          @click="choice.week = 10"
          class="label ph3"
        >
          10週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 11,
            'fc--primary': choice.week === 11,
            'fc--white': choice.week !== 11,
          }"
          @click="choice.week = 11"
          class="label ph3"
        >
          11週後
        </div>
        <div
          :class="{
            'bc--secondary': choice.week === 12,
            'fc--primary': choice.week === 12,
            'fc--white': choice.week !== 12,
          }"
          @click="choice.week = 12"
          class="label ph3"
        >
          12週後
        </div>
        -->
      </div>
      <div class="bc--primary pb3 ph4 row--scroll-x">
        <div
          v-for="(day,date) in datesInWeek"
          :key="date"
          :class="{
            'bc--secondary': choice.date === date,
            'fc--primary': choice.date === date,
            'fc--white': choice.date !== date,
          }"
          @click="choice.date = date"
          class="circle circle--size-6 fs1"
        >
          <div>
            {{ spiderman.moment(date).format('MM/DD') }}
          </div>
          <div>
            ({{ spiderman.moment(date).locale('zh_cn').format('dd') }})
          </div>
        </div>
      </div>
    </div>
    <Shift
      v-for="shift in shifts"
      :key="shift"
      :shift="shift"
      @click="chooseShift(shift)"
      class="mb3"
    />
  </div>

  <Making
    v-else-if="page === 'making'"
    @cancel="page = 'showing'"
    :clinic="clinic"
    :shift="chosenShift"
    :notes="choice.notes"
    v-model:modelIdentity="identity"
    v-model:modelMemberInfo="memberInfo"
    v-model:modelSelectedNote="selectedNote"
    @makeAppointment="makeAppointment"
    @clearMemberInfo="clearMemberInfo"
  />

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toShowing="toShowing"
    @toQuery="toQuery"
  />
</template>

<script>
import {
  ref, onMounted, reactive, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';
import Making from './pages/Making.vue';
import Shift from './components/Shift.vue';

export default {
  components: { Shift, Making },
  setup() {
    const page = ref('initialization');
    let schedule = [];
    const clinic = ref(null);
    const choice = reactive({
      division: '',
      notes: [],
      week: 0,
      date: '',
    });
    const datesInWeek = ref({});
    const shifts = ref([]);
    const chosenShift = ref(null);
    const identity = ref('');
    const memberInfo = ref({
      name: '',
      id: '',
      birthdate: '',
      mobile: '',
    });
    const selectedNote = ref('');
    const router = useRouter();

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        schedule = await api.appointment.getSchedule(composable.member);
        clinic.value = spiderman.clinic[composable.member.info.clinic];
        const divisions = [];
        clinic.value.appointmentDivisions.forEach((division) => {
          divisions.push(division.division);
        });
        [choice.division] = divisions;

        page.value = 'showing';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    watch(
      () => choice.division,
      () => {
        clinic.value.appointmentDivisions.every((division) => {
          if (division.division === choice.division) {
            choice.notes = division.notes;
            return false;
          }
          return true;
        });
        selectedNote.value = '';
        if (choice.week !== 0) {
          choice.week = 0;
          return;
        }
        datesInWeek.value = getDatesInWeek();
        if (choice.date !== Object.keys(datesInWeek.value)[0]) {
          [choice.date] = Object.keys(datesInWeek.value);
          return;
        }
        shifts.value = getShifts();
      },
      { deep: true },
    );

    function getDatesInWeek() {
      const dates = {};
      schedule.forEach((aShift) => {
        if ((aShift.week === choice.week)
          && (aShift.division === choice.division)) {
          dates[aShift.date] = aShift.zhDayOfWeek;
        }
      });

      return dates;
    }

    function getShifts() {
      return schedule.filter(
        (aShift) => (aShift.division === choice.division)
          && (aShift.week === choice.week)
          && (aShift.date === choice.date),
      );
    }

    watch(
      () => choice.week,
      () => {
        datesInWeek.value = getDatesInWeek();
        [choice.date] = Object.keys(datesInWeek.value);
      },
      { deep: true },
    );

    watch(
      () => choice.date,
      () => {
        shifts.value = getShifts();
      },
      { deep: true },
    );

    function chooseShift(shift) {
      if (!shift.canMakeAppointment) {
        if (['乳房外科', '乳房影像科'].includes(shift.division)) {
          return;
        }
        composable.modal.popup('此時段已不開放線上預約，請來電洽詢。');
        return;
      }
      chosenShift.value = shift;
      if (composable.member.info.status === 'in') {
        identity.value = composable.member.info.name;
      }
      page.value = 'making';
    }

    watch(
      () => identity,
      () => {
        if (identity.value === composable.member.info.name) {
          const {
            name, twid: id, birthdate, mobile,
          } = composable.member.info;
          memberInfo.value = {
            name,
            id,
            birthdate,
            mobile,
          };
        } else if (identity.value === '') {
          clearMemberInfo();
        } else {
          const { name, id, birthdate } = composable.member.info.children
            .find((aChild) => aChild.name === identity.value);
          memberInfo.value = {
            name,
            id,
            birthdate,
            mobile: composable.member.info.mobile,
          };
        }
      },
      { deep: true },
    );

    function clearMemberInfo() {
      identity.value = '';
      memberInfo.value = {
        name: '',
        id: '',
        birthdate: '',
        mobile: '',
      };
    }

    async function makeAppointment() {
      try {
        spiderman.form.verify(memberInfo.value);
        chosenShift.value.note = selectedNote.value;
        spiderman.form.verify(chosenShift.value);
        memberInfo.value.birthdate = spiderman.moment(
          memberInfo.value.birthdate,
        ).format('YYYY-MM-DD');

        composable.loading.show('預約掛號中，請稍候');

        const response = await api.appointment.make(
          composable.member, memberInfo.value, chosenShift.value,
        );

        composable.modal.show({
          body: response.message,
          hasCloseButton: false,
          footer: [
            { content: '繼續預約', type: 'secondary', onClickEmit: 'toShowing' },
            { content: '前往預約查詢', type: 'primary', onClickEmit: 'toQuery' },
          ],
        });
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function toShowing() {
      composable.modal.close();
      page.value = 'showing';
    }

    function toQuery() {
      composable.modal.close();
      router.push({ path: '/appointment/doctor/query' });
    }

    return {
      page,
      composable,
      spiderman,
      clinic,
      choice,
      datesInWeek,
      shifts,
      chooseShift,
      chosenShift,
      identity,
      memberInfo,
      selectedNote,
      clearMemberInfo,
      makeAppointment,
      toShowing,
      toQuery,
    };
  },
};
</script>
